/**
 * 管理后台统计数据 store
 * 集中拉取仪表盘与分析页面所需的所有统计数据，供各页面复用。
 */
import { create } from "zustand";
import {
  statsApi,
  type DashboardStats,
  type VIPSalesData,
  type UserGrowthData,
  type LoginDistribution,
  type InvitationUsageData,
} from "@/services/api";

interface AdminStatsState {
  loading: boolean;
  error: string | null;
  dashboard: DashboardStats | null;
  vipSales: VIPSalesData[];
  userGrowth: UserGrowthData[];
  loginDistribution: LoginDistribution | null;
  invitation: InvitationUsageData | null;
  days: number;
  setDays: (days: number) => void;
  fetchAll: () => Promise<void>;
}

export const useAdminStatsStore = create<AdminStatsState>()((set, get) => ({
  loading: false,
  error: null,
  dashboard: null,
  vipSales: [],
  userGrowth: [],
  loginDistribution: null,
  invitation: null,
  days: 7,

  setDays: (days: number) => set({ days }),

  fetchAll: async () => {
    set({ loading: true, error: null });
    const { days } = get();
    try {
      const [dashboard, vipSales, userGrowth, loginDistribution, invitation] =
        await Promise.all([
          statsApi.getDashboard().catch(() => null),
          statsApi.getVIPSales(days).catch(() => []),
          statsApi.getUserGrowth(days).catch(() => []),
          statsApi.getLoginDistribution(days).catch(() => null),
          statsApi.getInvitationUsage().catch(() => null),
        ]);
      set({
        dashboard,
        vipSales,
        userGrowth,
        loginDistribution,
        invitation,
        loading: false,
      });
    } catch (err) {
      set({
        error: err instanceof Error ? err.message : "获取数据失败",
        loading: false,
      });
    }
  },
}));
